import { Component, EventEmitter, Input, Output } from "@angular/core";
import { IMetadataImage } from "../../../../viewer-components/interfaces/i-metadataimage";

@Component({
  selector: "lib-fullscreen-info",
  templateUrl: "./fullscreen-info.component.html",
  styleUrls: ["./fullscreen-info.component.scss"],
  standalone: false,
})
export class FullscreenInfoComponent {
  @Input() image: IMetadataImage;

  @Input() captureDate: string;

  @Input() shortName: string;

  @Input() mapCenterCoordinates: number[] = [];

  @Output("closeInfo") closeInfo: EventEmitter<any> = new EventEmitter();

  latLong: string = "";

  closeInfoModal(): void {
    this.closeInfo.emit();
  }
}
